import HolidayIcon from 'components/ReusableComponents/Icons/Holiday'

import styles from './RestrictedDateWarning.module.scss'

const RestrictedDateWarningUserInfo = ({ name }) => {
  return (
    <div className={styles.bar}>
      <div className={styles.iconHolder}>
        <HolidayIcon />
      </div>
      <div className={styles.textHolder}>
        <p className={styles.title}>Today is "{name}" where guest live.</p>
        <p className={styles.description}>
          {name} is a "do not call" date. Sending marketing messages is not recommended.
        </p>
      </div>
    </div>
  )
}

export default RestrictedDateWarningUserInfo
